import { ApolloClient } from '@apollo/client';
import { ValidationError } from 'yup';
import { IOrderRequest } from '../order-request-form';
import { queryOrderRequestProductInput } from '../../../../../../../services';

// Factory that builds a yup test asserting the row's product still belongs to
// the account's product catalog (account_products). A product can be removed
// from the catalog after an order request that references it was created — and
// the product input is locked on existing rows — so without this the stale
// product is only caught by the backend (a raw "is not in the account catalog"
// error on save). This surfaces it as a field-level error instead, and (with
// the form's validateOnMount) flags it the moment a drifted request is opened.
// The catalog query is cache-first, reusing what the product picker already
// fetched for this account.
export function makeIsProductInCatalog(apolloClient: ApolloClient<object>) {
    return async function (
        value: any,
        context: any,
    ): Promise<boolean | ValidationError> {
        const { product } = context.from[0]
            .value as IOrderRequest['order_request_products'][number];
        const { account_id } = context.from[1].value as IOrderRequest;

        if (!product || !account_id) return true;

        const result = await queryOrderRequestProductInput(apolloClient, {
            accountId: account_id,
        });

        const inCatalog = (result.data.getAccountProducts || []).some(
            (accountProduct) => accountProduct.product?.id === product.id,
        );

        if (!inCatalog) {
            return context.createError({
                message: `El producto ya no está en el catálogo del cliente`,
            });
        }

        return true;
    };
}
